/* eslint-disable */
import ReactDOM from 'react-dom'
import React, { useRef, useState } from 'react'
import * as THREE from 'three'

import { Canvas, useFrame, useThree } from 'react-three-fiber'

import { TransformSVGPath2} from '../Utils/TransformSVG'
import StadiumPaths from '../Utils/StadiumOutfields'
import Stadiums from '../Utils/Stadiums'

function Infield(props) {
    const mesh = useRef()

    const stadiums = new Stadiums()
    const { infield, hasTransform } = StadiumPaths[props.id] || {}
    const fieldPath = TransformSVGPath2(infield, hasTransform)

    const extrudeSettings = {
        depth: 2,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1,
    }
    return (
        <mesh
            ref={mesh}
            position={props.position || [0, 0, 0]}
            geometry={new THREE.ExtrudeGeometry(fieldPath, extrudeSettings)}
            material={
                new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    wireframe: false,
                    flatShading: false,
                    wireframeLinewidth: 0.4,
                    transparent: true,
                    opacity: 1,
                    side: THREE.DoubleSide,
                })
            }
        >
            {/* <extrudeGeometry attach="geometry" args={[fieldPath, extrudeSettings]} /> */}
        </mesh>
    )
}

export default Infield
